var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrvCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H12V1C12 0.45 11.55 0 11 0C10.45 0 10 0.45 10 1V2H6V1C6 0.45 5.55 0 5 0C4.45 0 4 0.45 4 1V2H2C1.45 2 1 2.45 1 3V14C1 14.55 1.45 15 2 15H14C14.55 15 15 14.55 15 14V3C15 2.45 14.55 2 14 2ZM13 13H3V6H13V13Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrvCalendar);
export default __webpack_public_path__ + "static/media/grv-calendar.c8c15df8df2327e9145e4e3fe3c5bfae.svg";
export { ForwardRef as ReactComponent };